import { ReactElement } from "react";
import { Button } from "src/components/ui/button";
import { ReactComponent as Download } from "src/assets/icons-redesign/download.svg";
import { Skeleton } from "src/components/ui/skeleton";
import { apiUrl } from "src/constants/config";
import InvisiblyApiService from "src/services/api/invisibly-api.service";
import { createShare } from "src/services/surveys/surveys.helpers";

type ResultsSidebarHeaderDownloadProps =
  | {
    variant: "download",
    isShare: boolean,
    surveyId: string,
    title: string,
  }
  | { variant: "cannotDownload" }
  | { variant: "skeleton" };

const ResultsSidebarHeaderDownload = (props: ResultsSidebarHeaderDownloadProps): ReactElement | null => {
  const { variant } = props;

  if (variant === "skeleton") {
    return <Skeleton className="w-32 h-12" />;
  }

  if (variant === "cannotDownload") {
    return null;
  }

  const handleDownload = () => {
    const { isShare, surveyId, title } = props;
    const url = createShare(`${apiUrl}/b2b/survey/${surveyId}/csv`, isShare, 'b2b');
    const fileName = title.trim().toLowerCase().split(' ').join('_') + '.csv';

    void InvisiblyApiService.invokeDownloadRequest(url, fileName);
  };

  return (
    <Button
      onClick={handleDownload}
      className=""
      size="med"
      title="Download survey data as a csv"
    >
      <Download className="size-10" />
    </Button>
  );
};

export default ResultsSidebarHeaderDownload;
export type { ResultsSidebarHeaderDownloadProps };
